export const TERMS_OF_SERVICE_EXPERIMENT = 'growth_terms_of_service_update_impacts'

export const ORGANIZATION_TERMS_STATUS_TAG = { type: 'ORGANIZATION_TERMS_STATUS', id: 'LIST' } as const

export const DISPLAY_MODES = {
  POPUP: 'popup',
  BANNER: 'banner',
} as const

export const TERMS_OF_SERVICE_VERSIONS_MAP = {
  '2025-12-10': 'https://calendly.com/legal',
  '2026-06-01': 'https://calendly.com/legal-updates',
} as const
